var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard",
    transform: "translate(-380.000000, -117.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(106.000000, 117.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "006-sun",
    transform: "translate(274.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22,15 C22,19.4182806 18.8929954,23 14.305795,23             C9.71859458,23 6,19.4182806 6,15 C6,10.5817194 9.71865574,7             14.3058562,7 C18.8930566,7 22,10.5817194 22,15 Z",
    id: "Path",
    fill: "#FEE45A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8952611,7 C14.5926032,7 14.2940037,7.01690796             14,7.04883868 C18.0547568,7.4887403 21.2094778,10.880466             21.2094778,15 C21.2094778,19.119534 18.0547568,22.5112597             14,22.9511613 C14.2940037,22.983092 14.5926032,23 14.8952611,23             C19.3713875,23 23,19.4182806 23,15 C23,10.5817194 19.3713278,7             14.8952611,7 Z",
    id: "Path",
    fill: "#FED402"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4999767,5 L14.2626086,5 C14.0812711,5             13.9546019,4.77571729 14.0154172,4.56226159 L14.69537,2.17496947             L15.2527852,0.217924992 C15.3355687,-0.0726416638             15.6644351,-0.0726416638 15.7472185,0.217924992             L16.3046337,2.17496947 L16.9845865,4.56226159 C17.0454019,4.77565434             16.9186822,5 16.7373951,5 L15.4999767,5 Z",
    id: "Path",
    fill: "#FEE45A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5000144,25 L16.7373898,25 C16.9187284,25             17.0453984,25.2242827 16.9845827,25.4377384 L16.3046258,27.8250305             L15.7472073,29.782075 C15.6644234,30.0726417 15.335555,30.0726417             15.2527711,29.782075 L14.6953526,27.8250305 L14.0153957,25.4377384             C13.9546304,25.2242827 14.0813004,25 14.2625886,25 L15.5000144,25 Z",
    id: "Path",
    fill: "#FEE45A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,15.4999767 L25,14.2626086 C25,14.0812711             25.2242827,13.9546019 25.4377384,14.0154172 L27.8250305,14.69537             L29.782075,15.2527852 C30.0726417,15.3355687 30.0726417,15.6644351             29.782075,15.7472185 L27.8250305,16.3046337 L25.4377384,16.9845865             C25.2242827,17.0454019 25,16.9186822 25,16.7373951 L25,15.4999767 Z",
    id: "Path",
    fill: "#FED402"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,15.5000144 L5,16.7373898 C5,16.9187284             4.77571729,17.0453984 4.56226159,16.9845827 L2.17496947,16.3046258             L0.217924992,15.7472073 C-0.0726416638,15.6644738             -0.0726416638,15.335555 0.217924992,15.2527711             L2.17496947,14.6953526 L4.56226159,14.0153957 C4.77571729,13.9546304             5,14.0813004 5,14.2625886 L5,15.5000144 Z",
    id: "Path",
    fill: "#FEE45A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.76688855,7.76692584 L6.63344708,8.90036726             C6.46733084,9.0664835 6.18685874,9.01805197 6.08607938,8.80585398             L4.95857762,6.43264368 L4.03420112,4.48709295 C3.89693492,4.19826609             4.19822867,3.89697236 4.4871208,4.03417328 L6.43267162,4.95848448             L8.805882,6.08598619 C9.01808,6.18676555 9.06644626,6.46730291             8.90039529,6.63335387 L7.76688855,7.76692584 Z",
    id: "Path",
    fill: "#FEE45A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2331171,22.2330742 L23.3665638,21.0996327             C23.5326808,20.9335165 23.8131542,20.981948 23.9139341,21.194146             L25.0415063,23.5673563 L25.9658218,25.5129071 C26.1030233,25.8017339             25.8017935,26.1030276 25.5129,25.9658267 L23.5673402,25.0415155             L21.1941189,23.9139485 C20.9819199,23.8131692 20.9335534,23.5326318             21.0996052,23.3665809 L22.2331171,22.2330742 Z",
    id: "Path",
    fill: "#FED402"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2330742,7.76682328 L21.0996327,6.63338181             C20.9335165,6.46726557 20.981948,6.18679347 21.194146,6.08601411             L23.5673563,4.95851235 L25.5129071,4.03420112 C25.8017339,3.89693492             26.1030276,4.19822867 25.9658267,4.4871208 L25.0415155,6.43267162             L23.9139485,8.805882 C23.8131692,9.01808 23.5326318,9.06644626             23.3665809,8.90039529 L22.2330742,7.76682328 Z",
    id: "Path",
    fill: "#FED402"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.76692584,22.2331767 L8.90036726,23.3666182             C9.0664835,23.5327344 9.01805197,23.8132065 8.80585398,23.9139859             L6.43264368,25.0414876 L4.48709295,25.9657989 C4.19826609,26.1030651             3.89697236,25.8017713 4.03417328,25.5128792 L4.95848448,23.5673284             L6.08598619,21.194118 C6.18676555,20.98192 6.46730291,20.9335537             6.63335387,21.0996047 L7.76692584,22.2331767 Z",
    id: "Path",
    fill: "#FEE45A"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.db1d9333b5ef898704fac8c25e761acb.svg";
export { ForwardRef as ReactComponent };